import { FoodItem } from './db-types';

export const foods5: FoodItem[] = [
  { id: "starfruit", en: "Starfruit", fr: "Carambole", category: "fruit" },
  { id: "strawberry", en: "Strawberry", fr: "Fraise", category: "fruit", keywords: ["strawberries","fraises"] },
  { id: "sultana", en: "Sultana", fr: "Sultane", category: "fruit" },
  { id: "tamarind", en: "Tamarind", fr: "Tamarin", category: "fruit" },
  { id: "tangerine", en: "Tangerine", fr: "Tangerine", category: "fruit" },
  { id: "watermelon", en: "Watermelon", fr: "Pastèque", category: "fruit" },
  { id: "amaranth", en: "Amaranth", fr: "Amarante", category: "grain" },
  { id: "arborio_rice", en: "Arborio Rice", fr: "Riz arborio", category: "grain" },
  { id: "barley", en: "Barley", fr: "Orge", category: "grain" },
  { id: "basmati_rice", en: "Basmati Rice", fr: "Riz basmati", category: "grain" },
  { id: "basmati", en: "Basmati Rice", fr: "Riz basmati", category: "grain" },
  { id: "black_quinoa", en: "Black Quinoa", fr: "Quinoa noir", category: "grain" },
  { id: "black_rice", en: "Black Rice", fr: "Riz noir", category: "grain" },
  { id: "bran_flakes", en: "Bran Flakes", fr: "Flocons de son", category: "grain" },
  { id: "brown_rice", en: "Brown Rice", fr: "Riz complet", category: "grain", keywords: ["riz brun"] },
  { id: "buckwheat", en: "Buckwheat", fr: "Sarrasin", category: "grain", keywords: ["blé noir"] },
  { id: "buckwheat_groats", en: "Buckwheat Groats", fr: "Graines de sarrasin", category: "grain", keywords: ["kasha"] },
  { id: "bulgur", en: "Bulgur", fr: "Boulgour", category: "grain" },
  { id: "carnaroli_rice", en: "Carnaroli Rice", fr: "Riz carnaroli", category: "grain" },
  { id: "cereal", en: "Cereal", fr: "Céréales", category: "grain" },
  { id: "corn_flakes", en: "Corn Flakes", fr: "Corn flakes", category: "grain" },
  { id: "cornmeal", en: "Cornmeal", fr: "Semoule de maïs", category: "grain" },
  { id: "couscous", en: "Couscous", fr: "Couscous", category: "grain" },
  { id: "cracked_wheat", en: "Cracked Wheat", fr: "Blé concassé", category: "grain" },
  { id: "cream_of_wheat", en: "Cream of Wheat", fr: "Crème de blé", category: "grain" },
  { id: "einkorn", en: "Einkorn", fr: "Petit épeautre", category: "grain" },
  { id: "farro", en: "Farro", fr: "Épeautre", category: "grain" },
  { id: "freekeh", en: "Freekeh", fr: "Freekeh", category: "grain" },
  { id: "granola", en: "Granola", fr: "Granola", category: "grain" },
  { id: "grits", en: "Grits", fr: "Grits", category: "grain" },
  { id: "hulled_barley", en: "Hulled Barley", fr: "Orge mondé", category: "grain" },
  { id: "instant_oats", en: "Instant Oats", fr: "Avoine instantanée", category: "grain" },
  { id: "israeli_couscous", en: "Israeli Couscous", fr: "Couscous perlé", category: "grain", keywords: ["ptitim"] },
  { id: "jasmine_rice", en: "Jasmine Rice", fr: "Riz jasmin", category: "grain" },
  { id: "kamut", en: "Kamut", fr: "Kamut", category: "grain" },
  { id: "millet", en: "Millet", fr: "Millet", category: "grain" },
  { id: "muesli", en: "Muesli", fr: "Muesli", category: "grain" },
  { id: "oat_bran", en: "Oat Bran", fr: "Son d'avoine", category: "grain" },
  { id: "oat_groats", en: "Oat Groats", fr: "Grains d'avoine", category: "grain" },
  { id: "oatmeal", en: "Oatmeal", fr: "Porridge", category: "grain", keywords: ["gruau"] },
  { id: "oats", en: "Oats", fr: "Avoine", category: "grain" },
  { id: "pearl_barley", en: "Pearl Barley", fr: "Orge perlé", category: "grain" },
  { id: "polenta", en: "Polenta", fr: "Polenta", category: "grain" },
  { id: "popcorn", en: "Popcorn", fr: "Pop-corn", category: "grain" },
  { id: "puffed_rice", en: "Puffed Rice", fr: "Riz soufflé", category: "grain" },
  { id: "quinoa", en: "Quinoa", fr: "Quinoa", category: "grain" },
  { id: "red_quinoa", en: "Red Quinoa", fr: "Quinoa rouge", category: "grain" },
  { id: "red_rice", en: "Red Rice", fr: "Riz rouge", category: "grain" },
  { id: "rice", en: "Rice", fr: "Riz", category: "grain" },
  { id: "rice_flakes", en: "Rice Flakes", fr: "Flocons de riz", category: "grain" },
  { id: "rolled_oats", en: "Rolled Oats", fr: "Flocons d'avoine", category: "grain" },
  { id: "rye", en: "Rye", fr: "Seigle", category: "grain" },
  { id: "rye_berries", en: "Rye Berries", fr: "Grains de seigle", category: "grain" },
  { id: "sorghum", en: "Sorghum", fr: "Sorgho", category: "grain" },
  { id: "spelt", en: "Spelt", fr: "Épeautre", category: "grain" },
  { id: "steel_cut_oats", en: "Steel Cut Oats", fr: "Gruau d'avoine", category: "grain" },
  { id: "sticky_rice", en: "Sticky Rice", fr: "Riz gluant", category: "grain" },
  { id: "sushi_rice", en: "Sushi Rice", fr: "Riz à sushi", category: "grain" },
  { id: "teff", en: "Teff", fr: "Teff", category: "grain" },
  { id: "triticale", en: "Triticale", fr: "Triticale", category: "grain" },
  { id: "wheat", en: "Wheat", fr: "Blé", category: "grain" },
  { id: "wheat_berries", en: "Wheat Berries", fr: "Grains de blé", category: "grain" },
  { id: "white_quinoa", en: "White Quinoa", fr: "Quinoa blanc", category: "grain" },
  { id: "white_rice", en: "White Rice", fr: "Riz blanc", category: "grain" },
  { id: "wild_rice", en: "Wild Rice", fr: "Riz sauvage", category: "grain" },
  { id: "basil", en: "Basil", fr: "Basilic", category: "herb" },
  { id: "bay_leaf", en: "Bay Leaf", fr: "Laurier", category: "herb", keywords: ["bay leaves","feuille de laurier"] },
  { id: "bouquet_garni", en: "Bouquet Garni", fr: "Bouquet garni", category: "herb" },
  { id: "chervil", en: "Chervil", fr: "Cerfeuil", category: "herb" },
  { id: "cilantro", en: "Cilantro", fr: "Coriandre", category: "herb", keywords: ["coriander leaf"] },
  { id: "culantro", en: "Culantro", fr: "Coriandre longue", category: "herb" },
  { id: "curly_parsley", en: "Curly Parsley", fr: "Persil frisé", category: "herb" },
  { id: "curry_leaves", en: "Curry Leaves", fr: "Feuilles de curry", category: "herb" },
  { id: "dill", en: "Dill", fr: "Aneth", category: "herb" },
  { id: "epazote", en: "Epazote", fr: "Épazote", category: "herb" },
  { id: "fines_herbes", en: "Fines Herbes", fr: "Fines herbes", category: "herb" },
  { id: "flat_leaf_parsley", en: "Flat-Leaf Parsley", fr: "Persil plat", category: "herb" },
  { id: "herbes_de_provence", en: "Herbes de Provence", fr: "Herbes de Provence", category: "herb" },
  { id: "holy_basil", en: "Holy Basil", fr: "Basilic sacré", category: "herb" },
  { id: "kaffir_lime", en: "Kaffir Lime Leaves", fr: "Feuilles de combava", category: "herb" },
  { id: "lavender", en: "Lavender", fr: "Lavande", category: "herb" },
  { id: "lemon_thyme", en: "Lemon Thyme", fr: "Thym citron", category: "herb" },
  { id: "lemon_verbena", en: "Lemon Verbena", fr: "Verveine citronnée", category: "herb" },
  { id: "lemongrass", en: "Lemongrass", fr: "Citronnelle", category: "herb" },
  { id: "marjoram", en: "Marjoram", fr: "Marjolaine", category: "herb" },
  { id: "mint", en: "Mint", fr: "Menthe", category: "herb" },
  { id: "oregano", en: "Oregano", fr: "Origan", category: "herb" },
  { id: "parsley", en: "Parsley", fr: "Persil", category: "herb" },
  { id: "peppermint", en: "Peppermint", fr: "Menthe poivrée", category: "herb" },
  { id: "rosemary", en: "Rosemary", fr: "Romarin", category: "herb" },
  { id: "sage", en: "Sage", fr: "Sauge", category: "herb" },
  { id: "savory", en: "Savory", fr: "Sarriette", category: "herb" },
  { id: "shiso", en: "Shiso", fr: "Shiso", category: "herb", keywords: ["perilla"] },
  { id: "spearmint", en: "Spearmint", fr: "Menthe verte", category: "herb" },
  { id: "tarragon", en: "Tarragon", fr: "Estragon", category: "herb" },
  { id: "thai_basil", en: "Thai Basil", fr: "Basilic thaï", category: "herb" },
  { id: "thyme", en: "Thyme", fr: "Thym", category: "herb" },
  { id: "adzuki_beans", en: "Adzuki Beans", fr: "Haricots azuki", category: "legume" },
  { id: "baked_beans", en: "Baked Beans", fr: "Haricots à la tomate", category: "legume" },
  { id: "beans", en: "Beans", fr: "Haricots", category: "legume" },
  { id: "black_beans", en: "Black Beans", fr: "Haricots noirs", category: "legume" },
  { id: "black_lentils", en: "Black Lentils", fr: "Lentilles noires", category: "legume", keywords: ["beluga"] },
  { id: "black_eyed_peas", en: "Black-Eyed Peas", fr: "Haricots à œil noir", category: "legume" },
  { id: "borlotti_beans", en: "Borlotti Beans", fr: "Haricots borlotti", category: "legume", keywords: ["cranberry beans"] },
  { id: "brown_lentils", en: "Brown Lentils", fr: "Lentilles brunes", category: "legume" },
  { id: "butter_beans", en: "Butter Beans", fr: "Haricots beurre", category: "legume" },
  { id: "cannellini", en: "Cannellini Beans", fr: "Haricots cannellini", category: "legume" },
  { id: "chickpeas", en: "Chickpeas", fr: "Pois chiches", category: "legume", keywords: ["garbanzo"] },
  { id: "edamame", en: "Edamame", fr: "Edamame", category: "legume" },
  { id: "fava_beans", en: "Fava Beans", fr: "Fèves", category: "legume", keywords: ["broad beans"] },
  { id: "firm_tofu", en: "Firm Tofu", fr: "Tofu ferme", category: "legume" },
  { id: "flageolet", en: "Flageolet Beans", fr: "Flageolets", category: "legume" },
  { id: "french_lentils", en: "French Lentils", fr: "Lentilles du Puy", category: "legume" },
  { id: "great_northern", en: "Great Northern Beans", fr: "Gros haricots blancs", category: "legume" },
  { id: "green_lentils", en: "Green Lentils", fr: "Lentilles vertes", category: "legume" },
  { id: "green_split_peas", en: "Green Split Peas", fr: "Pois cassés verts", category: "legume" },
  { id: "kidney_beans", en: "Kidney Beans", fr: "Haricots rouges", category: "legume" },
  { id: "lentils", en: "Lentils", fr: "Lentilles", category: "legume" },
  { id: "lima_beans", en: "Lima Beans", fr: "Haricots de Lima", category: "legume" },
  { id: "mung_beans", en: "Mung Beans", fr: "Haricots mungo", category: "legume" },
  { id: "natto", en: "Natto", fr: "Natto", category: "legume" },
  { id: "navy_beans", en: "Navy Beans", fr: "Haricots blancs", category: "legume" },
  { id: "pigeon_peas", en: "Pigeon Peas", fr: "Pois d'Angole", category: "legume" },
  { id: "pinto_beans", en: "Pinto Beans", fr: "Haricots pinto", category: "legume" },
  { id: "red_lentils", en: "Red Lentils", fr: "Lentilles corail", category: "legume" },
  { id: "refried_beans", en: "Refried Beans", fr: "Haricots frits", category: "legume" },
  { id: "seitan", en: "Seitan", fr: "Seitan", category: "legume" },
  { id: "silken_tofu", en: "Silken Tofu", fr: "Tofu soyeux", category: "legume" },
  { id: "smoked_tofu", en: "Smoked Tofu", fr: "Tofu fumé", category: "legume" },
  { id: "soy_curls", en: "Soy Curls", fr: "Émincés de soja", category: "legume" },
  { id: "soybeans", en: "Soybeans", fr: "Soja", category: "legume", keywords: ["edamame"] },
  { id: "split_peas", en: "Split Peas", fr: "Pois cassés", category: "legume" },
  { id: "tempeh", en: "Tempeh", fr: "Tempeh", category: "legume" },
  { id: "tvp", en: "Textured Vegetable Protein", fr: "Protéines de soja texturées", category: "legume", keywords: ["TVP"] },
  { id: "tofu", en: "Tofu", fr: "Tofu", category: "legume" },
  { id: "white_beans", en: "White Beans", fr: "Haricots blancs", category: "legume" },
  { id: "yellow_lentils", en: "Yellow Lentils", fr: "Lentilles jaunes", category: "legume" },
  { id: "yellow_split_peas", en: "Yellow Split Peas", fr: "Pois cassés jaunes", category: "legume" },
  { id: "andouille", en: "Andouille", fr: "Andouille", category: "meat" },
  { id: "andouillette", en: "Andouillette", fr: "Andouillette", category: "meat" },
  { id: "bacon", en: "Bacon", fr: "Bacon", category: "meat", keywords: ["lard fumé"] },
  { id: "beef", en: "Beef", fr: "Bœuf", category: "meat", keywords: ["boeuf"] },
  { id: "beef_liver", en: "Beef Liver", fr: "Foie de bœuf", category: "meat" },
  { id: "beef_roast", en: "Beef Roast", fr: "Rôti de bœuf", category: "meat" },
  { id: "beef_shank", en: "Beef Shank", fr: "Jarret de bœuf", category: "meat" },
  { id: "beef_short_ribs", en: "Beef Short Ribs", fr: "Travers de bœuf", category: "meat" },
  { id: "beef_tenderloin", en: "Beef Tenderloin", fr: "Filet de bœuf", category: "meat" },
  { id: "beef_tongue", en: "Beef Tongue", fr: "Langue de bœuf", category: "meat" },
  { id: "bison", en: "Bison", fr: "Bison", category: "meat" },
  { id: "boudin_noir", en: "Blood Sausage", fr: "Boudin noir", category: "meat" },
  { id: "bratwurst", en: "Bratwurst", fr: "Bratwurst", category: "meat" },
  { id: "brisket", en: "Brisket", fr: "Poitrine de bœuf", category: "meat" },
  { id: "chorizo", en: "Chorizo", fr: "Chorizo", category: "meat" },
  { id: "cooked_ham", en: "Cooked Ham", fr: "Jambon blanc", category: "meat" },
  { id: "coppa", en: "Coppa", fr: "Coppa", category: "meat" },
  { id: "cured_ham", en: "Cured Ham", fr: "Jambon cru", category: "meat" },
  { id: "elk", en: "Elk", fr: "Élan", category: "meat" },
  { id: "filet_mignon", en: "Filet Mignon", fr: "Filet mignon", category: "meat", keywords: ["tournedos"] },
  { id: "flank_steak", en: "Flank Steak", fr: "Bavette", category: "meat" },
  { id: "foie_gras", en: "Foie Gras", fr: "Foie gras", category: "meat" },
  { id: "goat", en: "Goat", fr: "Chèvre", category: "meat", keywords: ["cabri"] },
  { id: "ground_beef", en: "Ground Beef", fr: "Bœuf haché", category: "meat", keywords: ["viande hachée"] },
  { id: "ground_lamb", en: "Ground Lamb", fr: "Agneau haché", category: "meat" },
  { id: "ground_pork", en: "Ground Pork", fr: "Porc haché", category: "meat" },
  { id: "guanciale", en: "Guanciale", fr: "Guanciale", category: "meat" },
  { id: "ham", en: "Ham", fr: "Jambon", category: "meat" },
  { id: "hanger_steak", en: "Hanger Steak", fr: "Hampe", category: "meat" },
  { id: "hare", en: "Hare", fr: "Lièvre", category: "meat" },
  { id: "horse", en: "Horse Meat", fr: "Viande de cheval", category: "meat" },
  { id: "hot_dog", en: "Hot Dog", fr: "Saucisse de Francfort", category: "meat", keywords: ["frankfurter"] },
  { id: "italian_sausage", en: "Italian Sausage", fr: "Saucisse italienne", category: "meat" },
  { id: "jamon_iberico", en: "Jamón Ibérico", fr: "Jambon ibérique", category: "meat" },
  { id: "kielbasa", en: "Kielbasa", fr: "Kielbasa", category: "meat" },
  { id: "lamb", en: "Lamb", fr: "Agneau", category: "meat" },
  { id: "lamb_chop", en: "Lamb Chop", fr: "Côtelette d'agneau", category: "meat" },
  { id: "lamb_shank", en: "Lamb Shank", fr: "Souris d'agneau", category: "meat" },
  { id: "lamb_shoulder", en: "Lamb Shoulder", fr: "Épaule d'agneau", category: "meat" },
  { id: "lardons", en: "Lardons", fr: "Lardons", category: "meat" },
  { id: "leberkase", en: "Leberkäse", fr: "Leberkäse", category: "meat" },
  { id: "lamb_leg", en: "Leg of Lamb", fr: "Gigot d'agneau", category: "meat" },
  { id: "merguez", en: "Merguez", fr: "Merguez", category: "meat" },
  { id: "mortadella", en: "Mortadella", fr: "Mortadelle", category: "meat" },
  { id: "mutton", en: "Mutton", fr: "Mouton", category: "meat" },
  { id: "osso_buco", en: "Osso Buco", fr: "Osso buco", category: "meat" },
  { id: "oxtail", en: "Oxtail", fr: "Queue de bœuf", category: "meat" },
  { id: "pancetta", en: "Pancetta", fr: "Pancetta", category: "meat" },
  { id: "pate", en: "Pâté", fr: "Pâté", category: "meat" },
  { id: "pepperoni", en: "Pepperoni", fr: "Pepperoni", category: "meat" },
  { id: "pork", en: "Pork", fr: "Porc", category: "meat" },
  { id: "pork_belly", en: "Pork Belly", fr: "Poitrine de porc", category: "meat" },
  { id: "pork_chop", en: "Pork Chop", fr: "Côte de porc", category: "meat", keywords: ["côtelette"] },
  { id: "pork_liver", en: "Pork Liver", fr: "Foie de porc", category: "meat" },
  { id: "pork_loin", en: "Pork Loin", fr: "Longe de porc", category: "meat" },
  { id: "pork_ribs", en: "Pork Ribs", fr: "Travers de porc", category: "meat" },
  { id: "pork_sausage", en: "Pork Sausage", fr: "Saucisse de porc", category: "meat" },
  { id: "pork_shoulder", en: "Pork Shoulder", fr: "Épaule de porc", category: "meat" },
  { id: "pork_tenderloin", en: "Pork Tenderloin", fr: "Filet mignon de porc", category: "meat" },
  { id: "prime_rib", en: "Prime Rib", fr: "Côte de bœuf", category: "meat" },
  { id: "prosciutto", en: "Prosciutto", fr: "Jambon de Parme", category: "meat" },
  { id: "rabbit", en: "Rabbit", fr: "Lapin", category: "meat" },
  { id: "rack_of_lamb", en: "Rack of Lamb", fr: "Carré d'agneau", category: "meat" },
  { id: "ribeye", en: "Ribeye", fr: "Entrecôte", category: "meat" },
  { id: "rillettes", en: "Rillettes", fr: "Rillettes", category: "meat" },
  { id: "salami", en: "Salami", fr: "Salami", category: "meat" },
  { id: "serrano_ham", en: "Serrano Ham", fr: "Jambon Serrano", category: "meat" },
  { id: "sirloin", en: "Sirloin", fr: "Faux-filet", category: "meat", keywords: ["aloyau"] },
  { id: "skirt_steak", en: "Skirt Steak", fr: "Onglet", category: "meat" },
  { id: "spare_ribs", en: "Spare Ribs", fr: "Spare ribs", category: "meat" },
  { id: "steak", en: "Steak", fr: "Steak", category: "meat", keywords: ["bifteck"] },
  { id: "t_bone", en: "T-Bone", fr: "T-Bone", category: "meat" },
  { id: "terrine", en: "Terrine", fr: "Terrine", category: "meat" },
  { id: "tripe", en: "Tripe", fr: "Tripes", category: "meat" },
];
